'use strict';

// TODO: This is duplicated from the aggregation. Find a better solution to the problem of who picks a unit
function getUnit(sensor_type, sensor_version, position, conversion_function) {
    switch (conversion_function) {
        case 'temp_f':
            return '°F';
        case 'temp_c':
            return '°C';
        case 'water_usage':
            return 'gal';
        case 'gas_usage':
            return 'Ccf';
        case 'power_usage':
            return 'kW';
        case 'energy_usage':
            return 'kWh';
        case 'dist_km':
            return 'km';
        case 'mm_per_hour':
            return 'mm/h';
        case 'm_per_sec':
            return 'm/s';
        case 'pressure_pa':
            return 'Pa';
        case 'pressure_hpa':
            return 'hPa';
        case 'pressure_kpa':
            return 'kPa';
        case 'pressure_psig':
            return 'PSIG';
        case 'pressure_pa_gauge':
            return 'Pa (gauge)';
        case 'dist_cm':
            return 'cm'
    }

    // If we haven't found a unit yet, go by sensor type
    switch (sensor_type) {
        case 0:
            switch (position) {
                case 1:
                    return 'V';
                case 3:
                    return '%';
            }
            break;
        case 1:
            if (sensor_version < 5) {
                switch (position) {
                    case 1:
                        return 'V';
                    case 3:
                        return '%';
                }
            } else {
                switch (position) {
                    case 2:
                        return '%';
                    case 3:
                        return 'V';
                }
            }
            break;
        case 10:
            return 'kWh';
        case 11:
            if (position === 1 || position === 3 || position === 5) {
                return 'kW';
            }
            break;
        case 12:
            if (position === 2) {
                return '%';
            } else if (position === 3) {
                return 'ppm';
            }
            break;
        case 14:
            return 'lux';
        case 15:
            return 'gal';
        case 16:
            if (position === 1 || position === 3 || position === 5) {
                return 'kWh';
            }
            break;
        case 17:
            if (position === 2) {
                return '%';
            }
            break;
        case 19:
            return 'Ccf';
        case 20:
            if (position === 1) {
                return 'lux';
            } else if (position === 2) {
                return '%';
            }
            break;
        case 28:
            if (position === 1) {
                return 'events';
            }
            if (position === 2) {
                return 'lux';
            } else if (position === 4) {
                return '%';
            }
            break;
        case 30:
            switch (position) {
                case 2:
                    return '%';
                case 3:
                case 5:
                    return 'ppm';
                case 4:
                    return 'ppb';
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                    return 'μg/m³';
            }
            break;
        case 31:
            return 'ppm';
        case 34:
            if (sensor_version === 1) {
                switch (position) {
                    case 2:
                    case 102:
                    case 105:
                    case 108:
                    case 111:
                    case 114:
                        return '%';
                    case 3:
                    case 5:
                    case 112:   // CO
                        return 'ppm';
                    case 4:     // VOC
                    case 100:   // NO2
                    case 103:   // H2S
                    case 106:   // SO2
                    case 109:   // O3
                        return 'ppb';
                    case 6:     // PM 1
                    case 7:     // PM 2.5
                    case 8:     // PM 10
                        return 'μg/m³';
                    case 99:    // HCHO
                        return 'mg/m³';
                }
            } else if (sensor_version === 2 || sensor_version === 3 || sensor_version === 4) { // To support new positions for new Sensirion PM Sensor
                switch (position) {
                    case 2:
                    case 102:
                    case 105:
                    case 108:
                    case 111:
                    case 114:
                        return '%';
                    case 3:
                    case 5:
                    case 112:   // CO
                        return 'ppm';
                    case 4:     // VOC
                    case 100:   // NO2
                    case 103:   // H2S
                    case 106:   // SO2
                    case 109:   // O3
                        return 'ppb';
                    case 89:
                    case 90:
                    case 91:
                    case 92:
                        return 'μg/m³'; //Mass Concentration
                    case 93:
                    case 94:
                    case 95:
                    case 96:
                    case 97:
                        return '#/cm³'; //Number Concentration
                    case 98:
                        return 'μm'; //Typical Particle Size
                    case 99:    // HCHO
                        return 'mg/m³';
                }
            } else if (sensor_version === 5) {
                switch (position) {
                    case 2:
                    case 102:
                    case 105:
                    case 108:
                    case 111:
                    case 114:
                        return '%';
                    case 3:
                    case 5:
                    case 112:   // CO
                        return 'ppm';
                    case 4:     // VOC
                    case 100:   // NO2
                    case 103:   // H2S
                    case 106:   // SO2
                    case 109:   // O3
                        return 'ppb';
                    case 86:
                    case 87:
                    case 88:
                        return 'pcs/L'; //Number Concentration
                    case 89:
                    case 90:
                    case 91:
                        return 'μg/m³'; //Mass Concentration
                    case 99:    // HCHO
                        return 'mg/m³';
                }
            } else if (sensor_version === 6) {
                switch (position) {
                    case 2:
                    case 102:
                    case 105:
                    case 108:
                    case 111:
                    case 114:
                        return '%';
                    case 3:
                    case 5:
                    case 112:   // CO
                        return 'ppm';
                    case 4:     // VOC
                    case 100:   // NO2
                    case 103:   // H2S
                    case 106:   // SO2
                    case 109:   // O3
                        return 'ppb';
                    case 83:
                    case 84:
                    case 85:
                    case 86:
                    case 87:
                    case 88:
                        return 'pcs/m³'; //Number Concentration
                    case 99:    // HCHO
                        return 'mg/m³';
                }
            } else if (sensor_version === 7) {
                switch (position) {
                    case 2:
                    case 102:
                    case 105:
                    case 108:
                    case 111:
                    case 114:
                        return '%';
                    case 3:
                    case 5:
                    case 112:   // CO
                        return 'ppm';
                    case 4:     // VOC
                    case 100:   // NO2
                    case 103:   // H2S
                    case 106:   // SO2
                    case 109:   // O3
                        return 'ppb';
                    case 79:
                    case 80:
                    case 81:
                    case 82:
                    case 83:
                    case 84:
                    case 85:
                        return 'pcs/L'; //Number Concentration
                    case 86:
                    case 87:
                    case 88:
                    case 89:
                    case 90:
                    case 91:
                    case 92:
                        return 'μg/m³'; //Mass Concentration
                    case 99:    // HCHO
                        return 'mg/m³';
                }
            }
            break;
        case 35:
            switch (position) {
                case 2:
                    return '%';
                case 3:
                case 4:
                case 5:
                    return 'lux';
                case 9:
                case 10:
                case 11:
                    return 'db(A)';
                case 87:
                case 88:
                case 89:
                case 93:
                case 94:
                case 95:
                    return '°';
                case 90:
                case 91:
                case 92:
                case 96:
                case 97:
                case 98:
                case 99:
                    return 'm/s²';
                case 100:
                    return 'events';
            }
            break;
        case 100000:
        case 100001:
            switch (position) {
                case 1:
                case 3:
                case 11:
                case 20:
                case 22:
                case 29:
                case 31:
                case 36:
                    return '°F';
                case 2:
                case 4:
                case 9:
                case 35:
                case 37:
                case 42:
                    return '%';
                case 5:
                case 14:
                case 46:
                    return '°';
                case 6:
                case 13:
                case 45:
                    return 'mi';
                case 8:
                case 40:
                    return 'in/h';
                case 15:
                case 16:
                case 47:
                case 48:
                    return 'mph';
                case 10:
                    return 'Mbar';
                case 17:
                    return 'in';
            }
            break;
        case 100003:
        case 100004:
            switch (position) {
                case 1:
                case 3:
                case 11:
                case 20:
                case 22:
                case 29:
                case 31:
                case 36:
                    return '°C';
                case 2:
                case 4:
                case 9:
                case 35:
                case 37:
                case 42:
                    return '%';
                case 5:
                case 14:
                case 46:
                    return '°';
                case 6:
                case 13:
                case 45:
                    return 'km';
                case 8:
                case 25:
                case 40:
                    return 'mm/h';
                case 15:
                case 16:
                case 47:
                case 48:
                    return 'm/s';
                case 10:
                    return 'hPa';
                case 17:
                    return 'cm';
            }
            break;
        case 100005:
        case 100006:
            switch (position) {
                case 1:
                case 3:
                case 11:
                case 20:
                case 22:
                case 29:
                case 31:
                case 36:
                    return '°C';
                case 2:
                case 4:
                case 9:
                case 35:
                case 37:
                case 42:
                    return '%';
                case 5:
                case 14:
                case 46:
                    return '°';
                case 6:
                case 13:
                case 45:
                    return 'mi';
                case 8:
                case 25:
                case 40:
                    return 'mm/h';
                case 15:
                case 16:
                case 47:
                case 48:
                    return 'mps';
                case 10:
                    return 'hPa';
                case 17:
                    return 'cm';

            }
            break;
        case 100007:
        case 100008:
            switch (position) {
                case 1:
                case 3:
                case 11:
                case 20:
                case 22:
                case 29:
                case 31:
                case 36:
                    return '°C';
                case 2:
                case 4:
                case 9:
                case 35:
                case 37:
                case 42:
                    return '%';
                case 5:
                case 14:
                case 46:
                    return '°';
                case 6:
                case 13:
                case 45:
                    return 'mi';
                case 8:
                case 25:
                case 40:
                    return 'mm/h';
                case 10:
                    return 'hPa';
                case 17:
                    return 'cm';
                case 15:
                case 16:
                case 47:
                case 48:
                    return 'km/s';
            }
            break;
    }
    return '';
}

/**
 * Determines the type of IAQ (Indoor Air Quality) channel based on sensor information.
 * 
 * @param {number} sensor_type - The type of sensor.
 * @param {number} sensor_version - The version of the sensor.
 * @param {number} position - The position of the sensor.
 * @param {boolean} is_virtual - Indicates if the channel is virtual.
 * @returns {string} A string representing the IAQ channel type. 
 *                   For virtual channels, the return format is "virtual-{position}".
 */
function getIAQChannelType(sensor_type, sensor_version, position, is_virtual) {
    let type = '';

    // If it's a virtual channel, just use the position to identify them
    if(is_virtual){
        return `virtual-${position}`;
    }

    switch (sensor_type) {
        // Internal Sensor
        case 1:
            if (sensor_version >= 5) {
                switch (position) {
                    case 1:
                        type = 'temp';
                        break;
                    case 2:
                        type = 'hum';
                        break;
                }
            } else {
                switch (position) {
                    case 2:
                        type = 'temp';
                        break;
                    case 3:
                        type = 'hum';
                        break;
                }
            }
            break;
        // Old Environmental
        case 30:
            switch (position) {
                case 1:
                    type = 'temp';
                    break;
                case 2:
                    type = 'hum';
                    break;
                case 3:
                    type = 'co2';
                    break;
                case 4:
                    type = 'voc';
                    break;
                case 10:
                    type = 'pm25';
                    break;
                case 11:
                    type = 'pm10';
                    break;
            }
            break;
        // IAQ
        case 34:
            switch (position) {
                case 1: 
                    type = 'temp';
                    break;
                case 2: 
                    type = 'hum';
                    break;
                case 3: 
                    type = 'co2';
                    break;
                case 4: // parts_per_billion 
                    type = 'tvocnumber';
                    break;
                case 5: 
                    type = 'eco2';
                    break;
                case 6:  // micrograms_per_cubic_meter
                case 89: // micrograms_per_cubic_meter
                    type = 'pm1mass';
                    break;
                case 11: // no_units
                    type = 'pm1';
                    break;
                case 82: // parts_per_liter
                case 85: // parts_per_cubic_meter
                case 86: // parts_per_liter
                case 94: // parts_per_cubic_centimeter
                    type = 'pm1number';
                    break;
                case 7:  // micrograms_per_cubic_meter
                case 90: // parts_per_liter
                    type = 'pm25mass';
                    break;
                case 12: // no_units
                    type = 'pm25';
                    break;
                case 87: // parts_per_liter
                case 95: // parts_per_cubic_centimeter
                    type = 'pm25number';
                    break;
                case 8:  // micrograms_per_cubic_meter 
                case 92: // micrograms_per_cubic_meter
                    type = 'pm10mass';
                    break;
                case 14: // no_units
                    type = 'pm10';
                    break;
                case 88: // parts_per_liter
                case 97: // parts_per_cubic_centimeter
                    type = 'pm10number';
                    break;
                case 9:  // no unnits
                    type = 'pm03';
                    break;
                case 80: // parts_per_liter
                case 83: // parts_per_cubic_meter
                    type = 'pm03number';
                    break;
                case 10: // no_units
                    type = 'pm05';
                    break;
                case 81: // parts_per_liter
                case 84: // parts_per_cubic_meter
                case 93: // parts_per_cubic_centimeter
                    type = 'pm05number';
                    break;
                case 13: // no_units
                    type = 'pm5';
                    break;
                case 79: // parts_per_liter
                    type = 'pm01number';
                    break;
                case 91: // micrograms_per_cubic_meter
                    type = 'pm4mas';
                    break;
                case 96: // parts_per_cubic_centimeter
                    type = 'pm4number';
                    break;
                case 99: 
                    type = 'hcho';
                    break;
                case 100: 
                    type = 'no2';
                    break;
                case 103: 
                    type = 'h2s';
                    break;
                case 106: 
                    type = 'so2';
                    break;
                case 109: 
                    type = 'o3';
                    break;
                case 112: 
                    type = 'co';
                    break;
            }

            // Override duplicated sensor position based in its sensor version
            if (sensor_version === 5) {
                switch (position) {
                    case 91: // micrograms_per_cubic_meter
                        type = 'pm10mass';
                        break;
                }
            } else if (sensor_version === 6) {
                switch (position) {
                    case 86: // parts_per_cubic_meter
                        type = 'pm25number';
                        break;
                    case 87: // parts_per_cubic_meter
                        type = 'pm5number';
                        break;
                    case 88: // parts_per_cubic_meter
                        type = 'pm1number';
                        break;
                    case 91: // 
                        type = 'pm10mass';
                        break;
                }
            } else if (sensor_version === 7) {
                switch (position) {
                    case 83: // parts_per_liter
                        type = 'pm25number';
                        break;
                    case 84: // parts_per_liter
                        type = 'pm5number';
                        break;
                    case 85: // parts_per_liter
                        type = 'pm10number';
                        break;
                    case 86: // micrograms_per_cubic_meter
                        type = 'pm01mass';
                        break;
                    case 87: // micrograms_per_cubic_meter
                        type = 'pm03mass';
                        break;
                    case 88: // micrograms_per_cubic_meter
                        type = 'pm05mass';
                        break;
                    case 91: // micrograms_per_cubic_meter
                        type = 'pm5mass';
                        break;
                }
            } else if (sensor_version === 8) {
                switch (position) {
                    case 5: // micrograms_per_cubic_meter
                        type = 'tvocmass';
                        break;
                    case 91: // micrograms_per_cubic_meter
                        type = 'pm10mass';
                        break;
                }
            } else if (sensor_version === 9) {
                switch (position) {
                    case 5: // micrograms_per_cubic_meter
                        type = 'tvocmass';
                    case 91: // micrograms_per_cubic_meter
                        type = 'pm10mass';
                        break;
                }
            }
            break;
    }
    return type;
}

module.exports = {
    getUnit,
    getIAQChannelType
}


//////////////////
// WEBPACK FOOTER
// ./srv/common/channelUtils.js
// module id = 153
// module chunks = 7